exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n.iframe[data-v-79d655db] {\n  width: 100%;\n  height: 70vh;\n  /*设置高度百分比,一直调到只有一个滚动调为止*/\n  border: 0;\n  overflow: hidden;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n}", ""]);

// exports
